import imgPlaceholder from "@/views/blocks/shared/images/64.svg";
import { computed } from "vue";
import type { BlockDef } from "./block.interfaces";
import { arrayField, createBlock, headingField, htmlField } from "./blockBuilder";
import { useDefaultColors } from "./useDefaultColors";
import { WithSmallImages, WithSmallImagesProps } from "@/views/blocks/team/team";

export function useTeams() {
    const { colorDefaults } = useDefaultColors();

    const logosBlock = computed<BlockDef>(() =>
        createBlock<WithSmallImagesProps>({
            typeId: "WithSmallImages",
            type: "team",
            name: "With small images",
            component: WithSmallImages,
        })
            .withField("title", headingField("Title", "Our expert team", "h2"))
            .withField(
                "description",
                htmlField(
                    "Description",
                    "We're an innovative team of professionals committed to excellence in our field and focused on creating exceptional value for everyone we serve."
                )
            )
            .withArrayField(
                "members",
                arrayField(
                    "Member",
                    "members",
                    {
                        name: { label: "Name", type: "text" },
                        role: { label: "Role", type: "text" },
                        imageSrc: { label: "Image", type: "image" },
                        imageAlt: { label: "Image Alt", type: "text" },
                    },
                    [
                        {
                            name: "John Doe",
                            role: "CEO",
                            imageSrc: imgPlaceholder,
                            imageAlt: "John Doe",
                        },
                        {
                            name: "Jane Doe",
                            role: "CTO",
                            imageSrc: imgPlaceholder,
                            imageAlt: "Jane Doe",
                        },
                        {
                            name: "Garry Doe",
                            role: "CFO",
                            imageSrc: imgPlaceholder,
                            imageAlt: "Garry Doe",
                        },
                        {
                            name: "Goerge Doe",
                            role: "CMO",
                            imageSrc: imgPlaceholder,
                            imageAlt: "Goerge Doe",
                        },
                        {
                            name: "Elon Doe",
                            role: "Developer",
                            imageSrc: imgPlaceholder,
                            imageAlt: "Elon Doe",
                        },
                        {
                            name: "Alex Doe",
                            role: "Designer",
                            imageSrc: imgPlaceholder,
                            imageAlt: "Alex Doe",
                        },
                    ]
                )
            )
            .withStyleFields([
                colorDefaults.value.background,
                colorDefaults.value.text,
                colorDefaults.value.brand,
            ])
            .build()
    );

    return {
        blocks: computed(() => [logosBlock.value]),
    };
}
